import React, { Component, Fragment } from 'react';
import intl from 'react-intl-universal';
import EditUser from './EditUser';
import NewUser from './NewUser';
import AssignRole from './AssignRole';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';

import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import EditIcon from '@mui/icons-material/Edit';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import Switch from '@mui/material/Switch';
 


import { connect } from "react-redux";

import ShowRoleTendant from './ShowRoleTendant'


class AccountUserList extends Component {

    constructor(props) {
        super(props);
    
        this.state = {
          usersdata: [],
          active: "Y",
          limit: 10,
          page: 0,
          count: 0,
          sortmode: "asc",
          sortmodelevel: "asc",
          sort: "lastName",
          searchstring: "",
          changerole: "",
          changetendant: "",
          editmode: false,
          edituserdata: [],
          newuser: false
        }

     this.handleDeleteRole=this.handleDeleteRole.bind(this);
     this.handleCloseUser=this.handleEditUser.bind(this);
     this.handleNewUser=this.handleNewUser.bind(this)
     this.getuserdata=this.getuserdata.bind(this);
     this.handleshowactivuser=this.handleshowactivuser.bind(this);
    }

    componentDidMount() {
        this.getuserdata(this.props.apitoken, 0 , this.state.limit, this.state.sortmode, this.state.sort, this.state.active );
      }

      handleLimitChange = (event) => {
        this.setState ({
          limit: event.target.value
        })
  
      this.getuserdata(this.props.apitoken, this.state.page , event.target.value, this.state.sortmode, this.state.sort, this.state.active, this.state.searchstring);  
      };
    
      handlePageChange = (event, newPage) => {  
        console.log(newPage)
        this.setState ({
          page: newPage    
      })
      this.getuserdata(this.props.apitoken, newPage, this.state.limit, this.state.sortmode, this.state.sort,this.state.active, this.state.searchstring);  
      };


      fullsearch = (event) => {
        event.preventDefault()
        this.setState ({
          searchstring: event.target.searchstring.value,
          page: 0,
          loaddata: true
      })
      this.getuserdata(this.props.apitoken, this.state.page , this.state.limit, this.state.sortmodelevel, this.state.sort, this.state.active, event.target.searchstring.value); 
      }



    handleswitchuserstate = (userid, valueswitch) => { 
      console.log(userid + "|" + valueswitch);

      let json = "";
      json = '{';
      json += '"userId": "' + userid + '"';
      json += '}';
      // ToDo Make API Call
      if (valueswitch === true){

        this.deaktivateuser(this.props.apitoken,userid,json)
      }

      if (valueswitch === false){
        this.aktivateuser(this.props.apitoken,userid,json)
      }
    }
 


    handleDeleteRole = (userid,Id) => {  
        let json = "";
        json = '{';
        json += '"userId": "' + userid + '",';
        json += '"id": "' + Id + '",';
        json += '}';   

        console.log(json)
        this.deleteuserrole(this.props.apitoken,userid,Id,json) 
      };

      handleEditUser = (edituserid) => { 
         this.getsingeluserdata(this.props.apitoken,edituserid)
      }  


      handleCloseEditUser = (page) => { 
      this.setState ({
        editmode: false
      })
      this.getuserdata(this.props.apitoken, page , this.state.limit, this.state.sortmode, this.state.sort, this.state.active );
    }
      
      handleNewUser = () => { 
        this.setState ({
          newuser: true
        })
        
      }

      handleCloseNewUser = () => { 
        this.setState ({
          newuser: false
        })
      this.getuserdata(this.props.apitoken, this.state.page , this.state.limit, this.state.sortmode, this.state.sort, this.state.active );
      }


      handleshowactivuser (){
        /*this.setState(prevState => ({
          switchactivuser: !prevState.switchactivuser
        }));*/
        let helpactive = "Y";
        if (this.state.active === "Y"){
          this.setState ({
            active: "N",
            page: this.state.page    
        })
        helpactive = "N"
        } else {
          this.setState ({
            active: "Y",  
            page: this.state.page  
        })
        helpactive = "Y"
        }

        this.getuserdata(this.props.apitoken, this.state.page , this.state.limit, this.state.sortmode, this.state.sort, helpactive );
      }


      

      getuserdata (token,page,limit,sortmode,sort,active,searchstring)  {
            let apiurl = window.apiurl
      
            if (searchstring === undefined){
              searchstring = "";
            }

            if (searchstring !== ""){
              searchstring = searchstring+"*";
            }
            
            //console.log (active)
      
            fetch("https://"+apiurl+"/api/User/?pageNumber="+page+"&pageSize="+limit+"&sortmode="+sortmode+"&sort="+sort+"&ActiveOnly="+active+"&query="+searchstring+"", {
                method: 'GET',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'Authorization': 'Bearer ' + token,
                },
              })
                .then(res => res.json())
                .then(json => {
                  console.log("---------------")
                  console.log(json)
                  console.log("---------------")
                  /*
                  if (this.state.switchactivuser) {
                    let inactivuser = (json.data || []).filter(function(activeuser, i)  {
                      //console.log(activeuser.isActive)
                      if (activeuser.isActive){
                        return activeuser
                      }
                    })
                    
                    this.setState ({
                      usersdata: inactivuser,
                      count: json.totalRecords
                    })
                    //console.log(inactivuser)
                   } else {
                    this.setState ({
                      usersdata: json.data,
                      count: json.totalRecords,
                  }) 
                   }*/

                   this.setState ({
                    usersdata: json.data,
                    count: json.totalRecords,
                }) 

                   


                   
                  
                })
                .catch(function(error) {
                    console.log(error.status);
                  });         
              }

          getsingeluserdata (token,userid)  {
                let apiurl = window.apiurl
          

                fetch("https://"+apiurl+"/api/User/"+userid, {
                    method: 'GET',
                    headers: {
                      'Accept': 'application/json',
                      'Content-Type': 'application/json',
                      'Authorization': 'Bearer ' + token,
                    },
                  })
                    .then(res => res.json())
                    .then(json => {
                      console.log("---------------")
                      console.log(json)
                      console.log("---------------")
                      this.setState ({
                          edituserdata: json, 
                          editmode: true
                      })  
                      
                    })
                    .catch(function(error) {
                        console.log(error.status);
                      });         
                  }

        


          deleteuserrole (token,userid,Id,json)  {
                    let apiurl = window.apiurl
                    console.log(json)
                    fetch("https://"+apiurl+"/api/User/"+userid+"/removerole/"+Id+"", {
                        method: 'DELETE',
                        headers: {
                          'Accept': 'application/json',
                          'Content-Type': 'application/json',
                          'Authorization': 'Bearer ' + token,
                        },
                        body: json
                      })
                        .then(res => res.json())
                        .then(json => {
                          console.log("---------------")
                          console.log(json)
                          console.log("---------------")
                          this.getuserdata(token, this.state.page + 1 , this.state.limit, this.state.sortmode, this.state.sort );  
                          
                        })
                        .catch(function(error) {
                            console.log(error.status);
                          });         
                      }

                      aktivateuser (token,userid,json)  {
                        let apiurl = window.apiurl
                       
                        fetch("https://"+apiurl+"/api/User/"+userid+"/activate", {
                            method: 'PUT',
                            headers: {
                              'Accept': 'application/json',
                              'Content-Type': 'application/json',
                              'Authorization': 'Bearer ' + token,
                            },
                            body: json
                          })
                            .then(res => res.json())
                            .then(json => {
                              //console.log("---------------")
                              //console.log(json)
                              //console.log("---------------")
                              this.getuserdata(token, this.state.page , this.state.limit, this.state.sortmode, this.state.sort );  
                              
                            })
                            .catch(function(error) {
                                console.log(error.status);
                              });         
                          }

                          deaktivateuser (token,userid,json)  {
                            let apiurl = window.apiurl
                           
                            fetch("https://"+apiurl+"/api/User/"+userid+"/deactivate", {
                                method: 'PUT',
                                headers: {
                                  'Accept': 'application/json',
                                  'Content-Type': 'application/json',
                                  'Authorization': 'Bearer ' + token,
                                },
                                body: json
                              })
                                .then(res => res.json())
                                .then(json => {
                                  console.log("---------------")
                                  console.log(json)
                                  console.log("---------------")
                                  this.getuserdata(token, this.state.page , this.state.limit, this.state.sortmode, this.state.sort );  
                                  
                                })
                                .catch(function(error) {
                                    console.log(error.status);
                                  });         
                              }

                      handleChange(e) {
                        this.setState({
                          [e.target.name]: e.target.value
                        })
                      }
                         

    render () {  
       
    let page = this.state.page + 1
    
    
    const { singeluserdata } = this.props;
   

     console.log(this.state)
        
        const loginuserid = singeluserdata.accountId
        const roles = this.props.roles
        const tendants = this.props.tendants
        const admintenants = this.props.admintenants
        
        //console.log(roles)
       
       if (this.state.editmode) {
        return (
          <Fragment>
            <EditUser token={this.props.apitoken} edituserdata={this.state.edituserdata} closedit={this.handleCloseEditUser} isadmin={true} tendants={tendants} page={page} />
          </Fragment>
        )
       }

       if (this.state.newuser) {
        return (
          <Fragment>
            <NewUser  closedit={this.handleCloseNewUser} />
          </Fragment>
        )
       }




        return (
            <Fragment>


      
            <Box component="form" onSubmit={this.fullsearch} sx={{ mt: 4 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={10} md={5} lg={5} xl={5}>
                <FormControl variant="standard" fullWidth sx={{ m: 1 }}>
                  <InputLabel htmlFor="input-with-icon-adornment">
                  {intl.get('LIST_SEARCH_LABEL')}
                  </InputLabel>
                  <Input
                    id="input-with-icon-adornment"
                    name="searchstring"
                    value={this.state.searchstring} 
                    onChange={(e) => this.handleChange(e)}
                    startAdornment={
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    }
                  />
                </FormControl>
                </Grid>
                <Grid item xs={1} sm={2} md={2} lg={2} xl={2}>
                <Button
                      type="submit"
                      variant="contained"
                      sx={{ mt: 1, mb: 1 }}
                    >
                     {intl.get('LIST_SEARCH_BUTTON')}
                    </Button>
                    </Grid> 
                    <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
                    <Button
                    onClick={() => {
                      this.handleNewUser()
                    }}
                      fullWidth={true}
                      variant="outlined"
                      sx={{ mt: 1, mb: 1 }}
                      startIcon={<PersonAddIcon />}
                    >
                        {intl.get('ADMIN_NEWUSER')}
                    </Button>
                     </Grid>    
            
                </Grid>
                </Box>
                    <Table>
                      <TableHead>
                        <TableRow>
                        <TableCell style={{width:'5%'}}>
                        <Switch
                    checked={this.state.switchactivuser}
                    onChange={this.handleshowactivuser}
                    inputProps={{ 'aria-label': 'controlled' }}
                    />
                      

                        </TableCell>
                          <TableCell style={{width:'24%'}}>
                          {intl.get('ADMIN_LISTHEAD_NAME')} {this.state.sortmode === "asc" &&
                              <ArrowDropDownIcon onClick={this.sortdescmessage} />
                            } 
                            {this.state.sortmode === "desc" &&
                               <ArrowDropUpIcon onClick={this.sortascmessage} />
                            }
                          </TableCell>
                          <TableCell style={{width:'40%'}}>
                          {intl.get('ADMIN_LISTHEAD_ROLLE')}  {this.state.sortmodelevel === "asc" &&
                              <ArrowDropDownIcon onClick={this.sortdesclevel} />
                            } 
                            {this.state.sortmodelevel === "desc" &&
                              <ArrowDropUpIcon onClick={this.sortasclevel} />
                            } 
                          </TableCell>
                          <TableCell style={{width:'20%'}}>
                          {intl.get('ADMIN_LISTHEAD_ADDROLLE')}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        
                        {this.state.usersdata.map((userdata) => (
                          <TableRow
                            hover
                            key={userdata.id}
                          >
                          <TableCell >
                          <Grid container spacing={0}>
                          {userdata.isActive &&
                          <Grid>
                          <CheckCircleOutlineIcon className="green" onClick={() =>this.handleswitchuserstate(userdata.id, true)}/>
                          </Grid>
                          }  
                          {userdata.isActive &&
                          <Grid>
                          <EditIcon onClick={() =>this.handleEditUser(userdata.id)}/>
                          </Grid>
                          }
                          {!userdata.isActive &&
                          <Grid>
                          <RemoveCircleOutlineIcon className="red" onClick={() =>this.handleswitchuserstate(userdata.id, false)}/>
                          </Grid>
                          }
                          
                          </Grid>
                          </TableCell>
                            <TableCell>
                                <Typography
                                  color="textPrimary"
                                  variant="body1"
                                >
                                  <strong>{userdata.lastName}</strong> {userdata.firstName}<br />
                                  <em>{userdata.email}</em> 
                                </Typography>
                              
                            </TableCell>
                            <TableCell>
                              
                            <ShowRoleTendant userid={userdata.id} auth={userdata.authorizations} tendants={tendants} handleDeleteRole={this.handleDeleteRole}/>

                           

                            
                              
                            </TableCell>
                              <TableCell>
                              {roles !== "" &&
                              <AssignRole loginuserid={loginuserid} roles={roles} admintenants={admintenants} userdata={userdata} getuserdata={this.getuserdata} page={this.state.page} limit={this.state.limit} sortmode={ this.state.sortmode} sort={this.state.sort} />
                              }
                              </TableCell>
                           
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                
             
                <TablePagination
                  component="div"
                  count={this.state.count}
                  onPageChange={this.handlePageChange}
                  onRowsPerPageChange={this.handleLimitChange}
                  page={this.state.page}
                  rowsPerPage={this.state.limit}
                  rowsPerPageOptions={[5, 10, 25]}
                />
              </Fragment>
        )
    }
}

const mapStateToProps = state => ({
  state: state,
  roles: state.getroles.roles,
  tendants: state.getroles.accounts,
  singeluserdata: state.getuserdata.userme,
  admintenants: state.getuserdata.admintenants
});

export default connect(mapStateToProps)(AccountUserList);
